// extracted by mini-css-extract-plugin
module.exports = {"Ppb2Search":"Ppb2Search_Ppb2Search__1ImET","Title":"Ppb2Search_Title__3aIq5"};